import { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Articles } from "../Articles";

const ArticleTextContainer = styled.div`
  position: relative;
  border: 0.5px solid #ffffff90;
  border-radius: 10px;
  background: #000d30;
  margin: 10%;
  padding: 5%;
  white-space: pre-line;

  @media screen and (max-width: 650px) {
    width: 80%;
    margin: 5%;
    margin-top: 25%;

    img {
      width: 80%;
    }
  }
`;

const IconImg = styled.img`
  display: block;
  margin-left: auto;
  margin-top: -15%;

  @media screen and (max-width: 650px) {
    display: none;
  }
`;

const ArticlePage = () => {
  const { id } = useParams<string>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <ArticleTextContainer>
      <IconImg src={Articles[parseInt(id) - 1].icon} />
      <h1 style={{ padding: "0" }}>{Articles[parseInt(id) - 1].title}</h1>{" "}
      <div
        dangerouslySetInnerHTML={{ __html: Articles[parseInt(id) - 1].text }}
      />
    </ArticleTextContainer>
  );
};

export default ArticlePage;
